<template>
    <div class="api-goal-modal">
        <GoalModal
            :is-open="isOpen"
            :goal-tip-link="toolTipLink"
            :goal-tip-text="$t('funnel.edit.api.call.tip.text')"
            :summary-text="$t('funnel.edit.api.summary')"
            :title="$t('funnel.edit.api.title')"
            @update-config="updateConfig"
            @close-modal="closeModal"
        >
            <template #goalParameters>
                <DsInputField
                    v-model="integration"
                    data-qa="integration-input"
                    name="integration"
                    :label="labelIntegration"
                    autofocus
                    required
                />
                <DsInputField
                    v-model="callName"
                    data-qa="call-name-input"
                    name="callName"
                    :label="labelCallName"
                    autofocus
                    required
                />
            </template>
        </GoalModal>
    </div>
</template>

<script>
import GoalModal from '../goalModal/GoalModal.vue';
import { utils } from '../../../utils/legacy-utils';

export default {
    components: {
        GoalModal,
    },

    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        appInfo: {
            type: Object,
            required: true,
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                    integration: '',
                    callName: '',
                },
            }),
        },
    },
    emits: ['close-modal', 'update-cell-value'],

    data() {
        return {
            integration: this.cell?.value?.integration ?? '',
            callName: this.cell?.value?.callName ?? null,
            labelIntegration: this.$t('funnel.edit.api.integration'),
            labelCallName: this.$t('funnel.edit.api.call.name'),
        };
    },

    computed: {
        isSpaApp() {
            return this.appInfo?.appEditionFlags?.spaApp;
        },
        toolTipLink() {
            return this.isSpaApp ? this.$t('funnel.edit.api.tip.url.keap') : this.$t('funnel.edit.api.tip.url.classic');
        },
        appName() {
            return this.appInfo?.appName;
        },
    },

    mounted() {
        if (!this.integration) {
            this.integration = this.appName;
        }
    },

    methods: {
        updateConfig() {
            if (this.validateConfig()) {
                const cell = { ...this.cell };

                cell.value = cell.value || {};
                cell.value.integration = utils.removeNonAlphaNumeric(this.integration);
                cell.value.callName = utils.removeNonAlphaNumeric(this.callName);

                this.$emit('update-cell-value', { cell });
            }
        },

        validateConfig() {
            let valid = true;

            const regExAlphanumeric = /^[A-Za-z0-9]+$/;

            if (!this.integration || this.integration?.trim()?.length <= 0) {
                this.labelIntegration = this.$t('funnel.edit.api.integration.required');
                valid = false;
            } else if (!regExAlphanumeric.test(this.integration)) {
                this.labelIntegration = this.$t('funnel.edit.api.integration.alphanumeric');
                valid = false;
            } else if (this.callName?.toLowerCase().includes(this.integration?.toLowerCase())) {
                this.labelCallName = this.$t('funnel.edit.api.containing.error');
                valid = false;
            }

            if (!this.callName || this.callName?.trim()?.length <= 0) {
                this.labelCallName = this.$t('funnel.edit.api.call.name.required');
                valid = false;
            } else if (!regExAlphanumeric.test(this.callName)) {
                this.labelCallName = this.$t('funnel.edit.api.call.name.alphanumeric');
                valid = false;
            }

            return valid;
        },

        closeModal() {
            this.$emit('close-modal');
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
